module.exports = __webpack_public_path__ + "img/website_btn.c34d31b7.svg";